<template>
    <stripe-form
        v-if="form === 'stripe'"
        @resetServer="$emit('resetServer')"
        @token="$emit('token', $event)"
        @state="$emit('state', $event)"
       :formBus="formBus" 
    ></stripe-form>
    <card-connect-form
        v-else-if="form === 'card_connect'"
        @resetServer="$emit('resetServer')"
        @token="$emit('token', $event)"
        @state="$emit('state', $event)"
       :formBus="formBus"
    >
    </card-connect-form>
</template>

<script>
    import CardConnectForm from './CardConnectForm'
    import StripeForm from './StripeForm'
    import { mapGetters } from 'vuex'

    export default {
        name: 'CardForm',
        components: {
            CardConnectForm,
            StripeForm
        },
        props: ['formBus', 'processor'],
        computed: {
            ...mapGetters(['paymentProcessor']),
            form() {
                return this.processor || this.paymentProcessor
            }
        }
    }
</script>
